// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "offlinePrototype" + "." + "4a073f667366db9c5375" + ".css";
};